import React from 'react';
import ContentLoader from 'react-content-loader';

const SeatingChartSkeleton = () => (
  <ContentLoader
    speed={1.4}
    width="100%"
    height="100%"
    backgroundColor="rgba(0,0,0,0.06)"
    foregroundColor="rgba(0,0,0,0.18)"
  >
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
  </ContentLoader>
);

export default SeatingChartSkeleton;
